angular.module('impactx.subsequentpurchaseorderdata').service('SubsequentPurchaseOrderDataService', SubsequentPurchaseOrderDataService);

SubsequentPurchaseOrderDataService.$inject = ['$mdDialog', '$route'];

function SubsequentPurchaseOrderDataService($mdDialog,$route) {

    var self = this;

    self.openViewDialog = function (event, prsId, desId, pohId) {
        return $mdDialog.show({
            controller: 'SubsequentPurchaseOrderDataViewDialogCtrl',
            controllerAs: 'ctrl',
            locals: {
                prsId: prsId,
                pohId: pohId,
                desId: desId
            },
            templateUrl: 'modules/subsequentpurchaseorderdata/templates/subsequent-purchase-order-view-dialog.html',
            parent: angular.element(document.body),
            bindToController: true,
            targetEvent: event,
            clickOutsideToClose: false
        });
    };

    self.openEditDialog = function($event, id, type) {
        $mdDialog.show({
            controller: 'EditSPOCtrl',
            controllerAs: 'spoInfoCtrl',
            templateUrl: 'modules/subsequentpurchaseorderdata/templates/subsequent-purchase-order-info-dialog.html',
            parent: angular.element(document.body),
            targetEvent: $event,
            clickOutsideToClose: false,
            bindToController: true,
            locals: {
                id: id,
                type: type
            }
        }).then(function(){
            $route.reload();
        });
    }

    self.initWatch = function (scope)
    {
        scope.targetInvisibleCounter = {}; // How many conditions are currently making the field invisible
        let countDown = scope.data.conditionList.length; // Ignore initialCalls for non penalties
        scope.data.conditionList.forEach(function (condition)
        {
            const field = scope.data[condition.source];
            if(!field)
            {
                return;
            }
            if(!scope.targetInvisibleCounter.hasOwnProperty(condition.target))
            {
                scope.targetInvisibleCounter[condition.target] = 0;
            }
            // Initial evaluation must be different from true/false
            condition.currentEvaluation = undefined;
            // Watch
            scope.$watch(function () {
                    return field[field.visibleType]
                }, function (newVal) {
                var secondValue = newVal ? newVal.secondValue : undefined;
                const evaluation = condition.value == newVal || condition.value == secondValue;
                if(evaluation === condition.currentEvaluation)
                {
                    return;
                }
                condition.currentEvaluation = evaluation;

                if(evaluation)
                {
                    scope.targetInvisibleCounter[condition.target]--;
                    if(countDown > 0)
                    {
                        scope.targetInvisibleCounter[condition.target]++;
                    }
                }
                else
                {
                    scope.targetInvisibleCounter[condition.target]++;
                }
                const target = scope.data[condition.target];
                const oldVisible = target.visible;
                target.visible = scope.targetInvisibleCounter[condition.target] === 0;
                if(oldVisible !== target.visible && oldVisible === true)
                {
                    target[target.visibleType] = null;
                }
                if(countDown > 0)
                {
                    countDown--;
                }
            });
        });
    }


    return {
        openViewDialog: self.openViewDialog,
        openEditDialog: self.openEditDialog,
        initWatch: self.initWatch,
    };

}